import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function Images() {
  return (
    <>
      <div className="section">
        <Container>
          <Row>
            <Col md="5">
              <div className="sw_home_img">
                <img
                  alt="..."
                  src={require("assets/img/dispensing_vector_small.png")}
                ></img>
              </div>
            </Col>
            <Col md="7">
              <div className="sw_home_content">
                <p>
                  eDISP simplifies management of patient dispensing in ART
                  pharmacies under Benin Ministry of Health. The tool can be
                  used to keep track of ART patient information, dispense to
                  existing patients, register new patients, manage dispensary
                  stock and generate various reports in a few clicks. The data
                  from the facilities automatically compile and generate summary
                  reports to be used by decision makers at central level.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Images;
